// voux - Vuex Object Update
import Vue from "vue";

const voux = function(dest, data) {
  if (!Object.is(data)) {
    Vue.set(dest, data);
  } else {
    let seccs = Object.keys(data);
    seccs.forEach(sec => {
      voux(dest, sec, data[sec]);
    });
  }
};

Vue.use({
  install(Vue) {
    Vue.prototype.$voux = voux;
  }
});

export default voux;
